export default "__VITE_ASSET__DTSVS9Zd__"